import './Tournament.scss';
import { TournamentButton } from "./components/TournamentButton/TournamentButton";
import { TournamentModal } from "./components/TournamentModal/TournamentModal";
import { observer } from "mobx-react";
import { authStore, tournamentStore } from "../../../platform/stores";
import { NewTournamentModal } from "./components/NewTournamentModal/NewTournamentModal";
import { TournamentPrizeModal } from './components/TournamentPrizeModal/TournamentPrizeModal';

export const Tournament = observer(() => {
  const { activeTournament, mainModalIsOpened } = tournamentStore;

  return (
    <div className="tournament">
      {activeTournament && (
        <>
          <TournamentButton/>
          {mainModalIsOpened && <TournamentModal/>}
          <NewTournamentModal/>
        </>
      )}
      {authStore.accessToken && <TournamentPrizeModal/>}
    </div>
  );
});